import format from 'date-fns/format'
import subDays from 'date-fns/sub_days'
import { push } from 'connected-react-router'
import { timeout, delay } from '@ynap/promise-utils'
import { OrderHistory, ResponseError } from '@ynap/api-utils'
import {
    FETCH_ORDER_HISTORY_ERROR,
    FETCH_ORDER_HISTORY_REQUEST,
    FETCH_ORDER_HISTORY_SUCCESS,
    OrderHistoryCategory,
    OrderHistoryAction
} from '../constants/ActionTypes'
import { clearOrderHistory } from './clearOrderHistory'
import type { RawOrderHistory } from 'app/types/orders'

function fetchOrderHistoryRequest(category: OrderHistoryCategory): OrderHistoryAction {
    return {
        type: FETCH_ORDER_HISTORY_REQUEST,
        payload: { category },
    }
}

function fetchOrderHistorySuccess(data: RawOrderHistory, category: OrderHistoryCategory, clearState: boolean): OrderHistoryAction {
    return {
        type: FETCH_ORDER_HISTORY_SUCCESS,
        payload: {
            data,
            category,
            clearState,
        },
    }
}

function fetchOrderHistoryError(category: OrderHistoryCategory): OrderHistoryAction {
    return {
        type: FETCH_ORDER_HISTORY_ERROR,
        payload: { category },
    }
}

export default function fetchOrderHistory(pageNumber = 1, pageSize = 6, category: OrderHistoryCategory = 'recent', clearState = false) {
    return (dispatch, getState, fetch) => {
        const { config, locale, router = {}, uberToken } = getState()
        const { pastOrderDate = '01-01-2016', recentOrderDays = 28 } = config.head
        const { country, language, langId } = locale
        const { location = {} } = router
        const { pathname } = location
        const { clientRequest } = config.head || config
        const { baseUrl, clientId, clientSecret } = config.watsonService || config.global.services.commerce
        const { brandId } = config.watsonService || config.global.application

        if (clearState) {
            dispatch(clearOrderHistory(category))
        }

        if (!uberToken) {
            return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`))
        }

        dispatch(fetchOrderHistoryRequest(category))
        let dateFrom = pastOrderDate
        let dateTo = format(Date.now(), 'DD-MM-YYYY')

        if (category && category === 'recent') {
            dateFrom = format(subDays(Date.now(), recentOrderDays), 'DD-MM-YYYY')
        }

        if (category && category === 'past') {
            dateTo = format(subDays(Date.now(), recentOrderDays + 1), 'DD-MM-YYYY')
        }

        const request = OrderHistory.getOrderHistory({
            baseUrl,
            brandId,
            country,
            language,
            langId,
            uberToken,
            clientId,
            clientSecret,
            pageNumber,
            pageSize,
            dateFrom,
            dateTo,
        })

        
        //todo look at if this is shareable across state packages
        return delay(timeout<Response>(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((res) => {
                const { ok, status } = res

                if (ok) {
                    return res.json().then((json: RawOrderHistory) => dispatch(fetchOrderHistorySuccess(json, category, clearState)))
                } else if (status === 401 || status === 403) {
                    return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`))
                }

                throw new ResponseError(res)
            })
            .catch((error) => {
                dispatch(fetchOrderHistoryError(category))
                throw error
            })
    }
}
